import axios from 'axios'
import global from '@/global/variable.js'

// 获取产品列表
export function getList(data) {
  const url = global.requestUrl + '/product/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建产品信息
export function createOne(data) {
  const url = global.requestUrl + '/product/create'
  return axios.post(url, data)
}

// 更新产品信息
export function updateOne(data) {
  const url = global.requestUrl + '/product/update'
  return axios.post(url, data)
}

// 删除产品信息
export function deleteOne(data) {
  const url = global.requestUrl + '/product/delete/' + data.id
  return axios.get(url)
}
